// The marketing web site: its stylesheets and the controllers for its
// scroll-linked sections. A separate entry from main.ts so none of it is in the
// bundle every app and admin page loads. The page blocks render the tag for
// this inside #body-content, so it arrives with the markup on a boosted
// navigation and Stimulus connects the controllers to what was just swapped in.
import "~/css/web/index.css";
import { Stimulus } from "~/app";
import WebAlertController from "~/controllers/web-alert";
import WebDeckController from "~/controllers/web-deck";
import WebFetcherController from "~/controllers/web-fetcher";
import WebHalftoneController from "~/controllers/web-halftone";
import WebHandoffController from "~/controllers/web-handoff";
import WebHeroController from "~/controllers/web-hero";
import WebMcpController from "~/controllers/web-mcp";
import WebPatternController from "~/controllers/web-pattern";
import WebPayController from "~/controllers/web-pay";
import WebPersonasController from "~/controllers/web-personas";
import WebQuoteController from "~/controllers/web-quote";
import WebRevealController from "~/controllers/web-reveal";
import WebScatterController from "~/controllers/web-scatter";
import WebStepsController from "~/controllers/web-steps";
import WebSubsController from "~/controllers/web-subs";
import WebThemeController from "~/controllers/web-theme";
import WebUnderlinesController from "~/controllers/web-underlines";
import WebVideoController from "~/controllers/web-video";

Stimulus.register("web-alert", WebAlertController);
Stimulus.register("web-deck", WebDeckController);
Stimulus.register("web-fetcher", WebFetcherController);
Stimulus.register("web-halftone", WebHalftoneController);
Stimulus.register("web-handoff", WebHandoffController);
Stimulus.register("web-hero", WebHeroController);
Stimulus.register("web-mcp", WebMcpController);
Stimulus.register("web-pattern", WebPatternController);
Stimulus.register("web-pay", WebPayController);
Stimulus.register("web-personas", WebPersonasController);
Stimulus.register("web-quote", WebQuoteController);
Stimulus.register("web-reveal", WebRevealController);
Stimulus.register("web-scatter", WebScatterController);
Stimulus.register("web-steps", WebStepsController);
Stimulus.register("web-subs", WebSubsController);
Stimulus.register("web-theme", WebThemeController);
Stimulus.register("web-video", WebVideoController);
Stimulus.register("web-underlines", WebUnderlinesController);
